export default "__VITE_ASSET__Cmvkyals__"